import React from 'react'
import { useRouter } from 'next/router'
import { GetServerSideProps } from 'next'

import SubMenuPage from '@features/faq/pages/SubMenuPage'
import { BASE_URL } from '@configs/config'
import { maintenanceHandler } from '@lib/maintenanceHandler'

const writerMenus = [
  {
    title: 'อยากปิดคอมเมนต์ทำอย่างไร',
    url: '/faq/writer?content=disableComment',
  },
  {
    title: 'ฉันสามารถเปลี่ยนหมวดหมู่นิยายได้หรือไม่/ทำอย่างไร',
    url: '/faq/writer?content=changeCategory',
  },
  {
    title: 'ฉันจะลงทะเบียนนักเขียนเพื่อรับรายได้อย่างไร',
    url: '/faq/writer?content=registerWriter',
  },
  {
    title: 'ฉันจะดาวน์โหลดใบหักภาษี ณ ที่จ่าย ได้ที่ไหน',
    url: '/faq/writer?content=downloadDocument',
  },
  { title: 'ส่วนแบ่งรายได้', url: '/faq/writer?content=profit' },
]

type ContentType =
  | 'disableComment'
  | 'changeCategory'
  | 'registerWriter'
  | 'downloadDocument'
  | 'profit'

const contents = {
  disableComment: (
    <div>
      <h1>อยากปิดคอมเมนต์ทำอย่างไร</h1>
      <ol>
        <li>
          <p>
            กด&nbsp;
            <span className='text-primary font-medium'>
              &ldquo;เข้าสู่ระบบ&rdquo;
            </span>
            &nbsp;และกดที่&nbsp;
            <span className='text-primary font-medium'>
              &ldquo;โปรไฟล์&rdquo;
            </span>
          </p>
        </li>
        <li>
          <p>
            เลือก&nbsp;
            <span className='text-primary font-medium'>
              &ldquo;จักรวาลงานเขียน&rdquo;
            </span>
          </p>
        </li>
        <li>
          <p>
            เลือก&nbsp;
            <span className='text-primary font-medium'>
              &ldquo;งานเขียนที่ต้องการปิดคอมเมนต์&rdquo;
            </span>
            &nbsp;และกด&nbsp;
            <span className='text-primary font-medium'>
              &ldquo;แก้ไข&rdquo;
            </span>
          </p>
        </li>
        <li>
          <p>
            กดที่ช่อง&nbsp;
            <span className='text-primary font-medium'>
              &ldquo;ผู้อ่านสามารถแสดงความคิดเห็นได้&rdquo;
            </span>
            &nbsp;เพื่อนำเครื่องหมายถูกออก และกด&nbsp;
            <span className='text-primary font-medium'>
              &ldquo;บันทึก&rdquo;
            </span>
            &nbsp;เพื่อปิดคอมเมนต์
          </p>
        </li>
      </ol>
      <p>
        <br />
      </p>
    </div>
  ),
  changeCategory: (
    <div>
      <h1>ฉันสามารถเปลี่ยนหมวดหมู่นิยายได้หรือไม่/ทำอย่างไร</h1>
      <ol>
        <li>
          <p>
            กด&nbsp;
            <span className='text-primary font-medium'>
              &ldquo;เข้าสู่ระบบ&rdquo;
            </span>
            &nbsp;และกดที่&nbsp;
            <span className='text-primary font-medium'>
              &ldquo;โปรไฟล์&rdquo;
            </span>
          </p>
        </li>
        <li>
          <p>
            เลือก&nbsp;
            <span className='text-primary font-medium'>
              &ldquo;จักรวาลงานเขียน&rdquo;
            </span>
          </p>
        </li>
        <li>
          <p>
            เลือก&nbsp;
            <span className='text-primary font-medium'>
              &ldquo;งานเขียนที่ต้องการเปลี่ยนหมวดหมู่&rdquo;
            </span>
            &nbsp;และกด&nbsp;
            <span className='text-primary font-medium'>
              &ldquo;แก้ไข&rdquo;
            </span>
          </p>
        </li>
        <li>
          <p>
            เลือกเปลี่ยน&nbsp;
            <span className='text-primary font-medium'>
              &ldquo;หมวดหมู่&rdquo;
            </span>
            &nbsp;ที่ต้องการ
          </p>
        </li>
        <li>
          <p>
            กรอกหรือเลือก&nbsp;
            <span className='text-primary font-medium'>
              &ldquo;แท็กแนะนำ&rdquo;
            </span>
            &nbsp;และกด&nbsp;
            <span className='text-primary font-medium'>
              &ldquo;บันทึก&rdquo;
            </span>
            &nbsp;เพื่อยืนยันการเปลี่ยนแปลง
          </p>
        </li>
      </ol>
    </div>
  ),
  registerWriter: (
    <div>
      <h1>ฉันจะลงทะเบียนนักเขียนเพื่อรับรายได้อย่างไร</h1>
      <ol>
        <li>
          <p>
            กด&nbsp;
            <span className='text-primary font-medium'>
              &ldquo;เข้าสู่ระบบ&rdquo;
            </span>
            &nbsp;แล้วกดที่&nbsp;
            <span className='text-primary font-medium'>
              &ldquo;รูปโปรไฟล์&rdquo;
            </span>
          </p>
        </li>
        <li>
          <p>
            เลือก&nbsp;
            <span className='text-primary font-medium'>
              &ldquo;จักรวาลนักเขียน&rdquo;
            </span>
          </p>
        </li>
        <li>
          <p>
            เลือก&nbsp;
            <span className='text-primary font-medium'>
              &ldquo;ลงทะเบียนเพื่อรับรายได้&rdquo;
            </span>
          </p>
        </li>
        <li>
          <p>กรอกข้อมูลพร้อมแนบสำเนาหลักฐานยืนยันให้ครบถ้วน ดังนี้</p>
        </li>
      </ol>
      <ul>
        <li>
          <p>ข้อมูลชื่อบุคคล/นิติบุคคล</p>
        </li>
        <li>
          <p>
            ที่อยู่ตามบัตรประชาชน/ตามหนังสือรับรองบริษัทหรือใบภพ 20
            (*กรณีเป็นนิติบุคคล
            เอกสารหนังสือรับรองจะต้องระบุวัตถุประสงค์ในการเผยแพร่หรือจัดจำหน่ายวรรณกรรมอิเล็กทรอนิกส์
            หรือวัตถุประสงค์ที่เกี่ยวข้อง)&nbsp;
          </p>
        </li>
        <li>
          <p>ที่อยู่ในการจัดส่งเอกสาร</p>
        </li>
        <li>
          <p>ข้อมูลบัญชีธนาคาร สำหรับโอนเงินรายได้จากแพลตฟอร์ม MaReads</p>
        </li>
      </ul>
      <ol start={5}>
        <li>
          <p>
            กด&nbsp;
            <span className='text-primary font-medium'>
              &ldquo;ส่งข้อมูล&rdquo;
            </span>
          </p>
        </li>
      </ol>
      <p>
        ข้อมูลจะถูกตรวจสอบและดำเนินการอนุมัติภายใน 3-7 วันทำการ
        (กรณีข้อมูลถูกต้องและครบถ้วน) หากต้องการสอบถามเพิ่มเติม
        กรุณาติดต่อทีมงานทาง&nbsp;
        <a href='mailto:write.support@mareads.com'>write.support@mareads.com</a>
      </p>
    </div>
  ),
  downloadDocument: (
    <div>
      <h1>ฉันจะดาวน์โหลดใบหักภาษี ณ ที่จ่าย ได้ที่ไหน</h1>
      <p>
        &nbsp; &nbsp;&nbsp;คุณสามารถดาวน์โหลดใบหักภาษี ณ
        ที่จ่ายจากเว็บไซต์กรมสรรพากรผ่านทาง&nbsp;
        <a href='https://epay.rd.go.th/' className='text-primary underline'>
          https://www.rd.go.th/
        </a>
        &nbsp; ดูขั้นตอนการดาวน์โหลดใบหักภาษี ณ ที่จ่ายเพิ่มเติม
        <a href='/withholding-tax' className='underline'>
          ที่นี่
        </a>
      </p>
      <div className='flex flex-col space-y-[10px] py-[20px]'>
        <img
          src='/images/faq/image8.jpg'
          className='max-w-[500px] w-full'
          alt='How to download doc'
        />
        <img
          src='/images/faq/image13.jpg'
          className='max-w-[500px] w-full'
          alt='How to download doc'
        />
        <img
          src='/images/faq/image10.jpg'
          className='max-w-[500px] w-full'
          alt='How to download doc'
        />
        <img
          src='/images/faq/image6.jpg'
          className='max-w-[500px] w-full'
          alt='How to download doc'
        />
        <img
          src='/images/faq/image15.jpg'
          className='max-w-[500px] w-full'
          alt='How to download doc'
        />
        <img
          src='/images/faq/image12.jpg'
          className='max-w-[500px] w-full'
          alt='How to download doc'
        />
        <img
          src='/images/faq/image1.jpg'
          className='max-w-[500px] w-full'
          alt='How to download doc'
        />
        <img
          src='/images/faq/image5.jpg'
          className='max-w-[500px] w-full'
          alt='How to download doc'
        />
        <img
          src='/images/faq/image9.jpg'
          className='max-w-[500px] w-full'
          alt='How to download doc'
        />
      </div>
    </div>
  ),
  profit: (
    <div>
      <h1>ส่วนแบ่งรายได้</h1>
      <img
        src='/images/faq/image16.jpg'
        alt='profit'
        className='max-w-[900px] w-full'
      />
    </div>
  ),
}

const defaultBreadCrumb = [
  { title: 'คำถามที่พบบ่อย', url: '/faq' },
  { title: 'การเป็นนักเขียน', url: '/faq/writer' },
]

function Writer({ url }: { url: string }) {
  const { query } = useRouter()
  return (
    <SubMenuPage
      menus={writerMenus}
      breadCrumbList={
        query?.content
          ? [
              ...defaultBreadCrumb,
              {
                title:
                  writerMenus.find(m => m.url.includes(String(query.content)))
                    ?.title || '',
                url:
                  writerMenus.find(m => m.url.includes(String(query.content)))
                    ?.url || '',
              },
            ]
          : defaultBreadCrumb
      }
      content={contents[query?.content as ContentType]}
      url={url}
    />
  )
}

export const getServerSideProps: GetServerSideProps = async ({ req }) => {
  return maintenanceHandler({
    url: `${BASE_URL}${req.url}`,
  })
}

export default Writer
